const inputCls = "w-full rounded-md border border-[#D4E6EC] bg-white px-3 py-2 text-sm text-[#0D2B3A] focus:outline-none focus:ring-2 focus:ring-[#0B6E8F]/30 focus:border-[#0B6E8F] disabled:bg-[#EAF5F7] disabled:text-[#47606B] transition-colors";

function Pills({ f, value, onChange, disabled }) {
  return (
    <div className="flex flex-wrap gap-2">
      {f.options.map((o, i) => (
        <button
          type="button"
          key={o}
          disabled={disabled}
          data-testid={`field-${f.k}-opt-${i}`}
          onClick={() => onChange(value === o ? "" : o)}
          className={`text-xs px-3 py-1.5 rounded-full border transition-colors ${value === o ? "bg-[#0B6E8F] text-white border-[#0B6E8F]" : "bg-white text-[#47606B] border-[#D4E6EC] hover:border-[#0B6E8F]"} disabled:opacity-70`}
        >
          {o}
        </button>
      ))}
    </div>
  );
}

function Control({ f, value, onChange, disabled }) {
  const common = { disabled, "data-testid": `field-${f.k}`, className: inputCls };
  switch (f.type) {
    case "textarea":
      return <textarea rows={3} {...common} value={value || ""} onChange={(e) => onChange(e.target.value)} />;
    case "select":
      return (
        <select {...common} value={value || ""} onChange={(e) => onChange(e.target.value)}>
          <option value="">— seleziona —</option>
          {f.options.map((o) => <option key={o} value={o}>{o}</option>)}
        </select>
      );
    case "radio":
      return <Pills f={f} value={value} onChange={onChange} disabled={disabled} />;
    case "guarantor": {
      const v = value || {};
      return (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
          <select disabled={disabled} data-testid={`field-${f.k}-chi`} className={inputCls} value={v.chi || ""} onChange={(e) => onChange({ ...v, chi: e.target.value })}>
            <option value="">Chi garantisce</option>
            {f.options.map((o) => <option key={o} value={o}>{o}</option>)}
          </select>
          <input disabled={disabled} data-testid={`field-${f.k}-note`} className={`${inputCls} sm:col-span-2`} placeholder="Note operative" value={v.note || ""} onChange={(e) => onChange({ ...v, note: e.target.value })} />
        </div>
      );
    }
    default: {
      const type = { date: "date", time: "time", datetime: "datetime-local", number: "number", money: "number" }[f.type] || "text";
      return <input type={type} step={f.type === "money" ? "0.01" : undefined} min={f.type === "number" || f.type === "money" ? 0 : undefined} {...common} value={value ?? ""} onChange={(e) => onChange(e.target.value)} />;
    }
  }
}

export function FieldInput({ f, value, onChange, disabled }) {
  return (
    <label className={`block ${f.wide ? "md:col-span-2" : ""}`}>
      <span className="block text-xs font-medium text-[#47606B] mb-1.5">
        {f.label}{f.required && <span className="text-[#0B6E8F]"> *</span>}
      </span>
      <Control f={f} value={value} onChange={onChange} disabled={disabled} />
    </label>
  );
}

export function SectionForm({ section, data, onField, disabled, children }) {
  return (
    <section className="rounded-xl border border-[#D4E6EC] bg-white p-5 sm:p-7 fade-up" data-testid={`section-${section.title.slice(0, 2).trim().toLowerCase().replace(/\s/g, "-")}`}>
      <h3 className="font-serif-it text-xl sm:text-2xl font-semibold text-[#0D2B3A] mb-5">{section.title}</h3>
      {section.fixed?.length > 0 && (
        <div className="mb-5 rounded-lg bg-[#EAF5F7] p-4 text-sm space-y-1">
          {section.fixed.map(([a, b]) => <div key={a}><span className="text-[#7B929C] text-xs uppercase tracking-wider">{a}</span><div className="font-medium">{b}</div></div>)}
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5">
        {section.fields.map((f) => <FieldInput key={f.k} f={f} value={data[f.k]} onChange={(v) => onField(f.k, v)} disabled={disabled} />)}
      </div>
      {children}
    </section>
  );
}
